import {
  SafeAreaView,
  StyleSheet,
  ImageBackground,
  Image,
  useWindowDimensions,
  Animated,
  Easing,
  Platform,
} from "react-native";
import React, { useState, useEffect, useRef } from "react";
import { Heading, Center, Box, Text, Pressable, HStack } from "native-base";

import { StackScreenProps } from "../types";
import { LinearGradient } from "expo-linear-gradient";
import AsyncStorage from "@react-native-async-storage/async-storage";

const CircularText = require("../assets/circular_text.png");
const MenuButton = require("../assets/menu_btn.png");
const HomeBg1 = require("../assets/woman_with_corn.jpg");
const HomeBg2 = require("../assets/man-with-tablet.jpg");
const HomeBg3 = require("../assets/home-slide-3.jpg");
const HomeBGOverlay = require("../assets/homepage_image_overlay.png");

const Twirl1 = require("../assets/twirl1.png");
const Twirl2 = require("../assets/twirl2.png");
const Twirl3 = require("../assets/star3.png");
const Twirl4 = require("../assets/star4.png");

const Home = ({ navigation }: StackScreenProps<"Home">) => {
  const [slide, setSlide] = useState(0);
  const [animatedValue, setAnimatedValue] = useState(new Animated.Value(0)); // for the circular text
  const [animatedValue2, setAnimatedValue2] = useState(new Animated.Value(0)); // for the buttons
  const [animatedValue3, setAnimatedValue3] = useState(new Animated.Value(0)); // for the twirls
  const [menuOpen, setMenuOpen] = useState(false);

  const slides = [
    { img: HomeBg1, text: "Welcome to OCP Africa" },
    {
      img: HomeBg2,
      text: "Contributing to a sustainable transformation of our country’s Food systems",
    },
    {
      img: HomeBg3,
      text: "Customized solutions to develop the agriculture ecosystem with Nigerian farmers and value chain stakeholders",
    },
  ];

  const { width, height } = useWindowDimensions();

  useEffect(() => {
    const interval = setInterval(() => {
      if (slide >= slides.length - 1) {
        setSlide(0);
      } else {
        setSlide(slide + 1);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [slide]);

  useEffect(() => {
    async function getData() {
      const menuState = await AsyncStorage.getItem("menuOpen");
      if (menuState) {
        // setMenuOpen(menuState == "0" ? false : true);
      }

      console.log({ menuState });

      fetch(
        `https://generous-bedbug-34811.kv.vercel-storage.com/get/keyFigures`,
        {
          headers: {
            Authorization: `Bearer AYf7ASQgNDFmYzZjY2UtZjdlMC00MTBmLTg3NmYtNzRiYjA2ZTIwYjRhMTgxM2U3MTBmMjMwNGIwNDhkYjA2Yzk3MTk4NmRjYjY=`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            AsyncStorage.setItem("keyFigures", data.result);
          }
        });
    }

    getData();
  }, []);

  const handleAnimation = () => {
    Animated.loop(
      Animated.timing(animatedValue, {
        toValue: 1,
        duration: 10000,
        easing: Easing.ease,
        useNativeDriver: Platform.OS != "web",
      })
    ).start();

    const animation3 = Animated.timing(animatedValue3, {
      toValue: 1,
      duration: 5000,
      easing: Easing.ease,
      useNativeDriver: Platform.OS != "web",
    });

    Animated.loop(animation3).start();
  };

  const handleTranslateAnimation = (reset = false) => {
    const animation = Animated.timing(animatedValue2, {
      toValue: 1,
      duration: 500,
      easing: Easing.bounce,
      useNativeDriver: true,
    });

    if (reset) {
      animation.reset();
    } else if (menuOpen) {
      animation.reset();

      // setMenuOpen(false);
    } else {
      animation.start();
      setMenuOpen(true);
      AsyncStorage.setItem("menuOpen", "1");
    }
  };

  const spin = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: ["0deg", "360deg"],
  });
  const spin2 = animatedValue3.interpolate({
    inputRange: [0, 1],
    outputRange: ["180deg", "360deg"],
  });
  const spin3 = animatedValue3.interpolate({
    inputRange: [0, 1],
    outputRange: ["0deg", "90deg"],
  });
  const spin4 = animatedValue3.interpolate({
    inputRange: [0, 1],
    outputRange: ["0deg", "270deg"],
  });

  const FadeInView = (props: any) => {
    const fadeAnim = useRef(new Animated.Value(0)).current; // Initial value for opacity: 0

    // useEffect(() => {
    //   Animated.timing(fadeAnim, {
    //     toValue: 10,
    //     duration: 1000,
    //     useNativeDriver: true,
    //     // easing: Easing.inOut(),
    //   }).start();
    // }, [fadeAnim, slide]);

    return (
      <Animated.View // Special animatable View
        style={{
          ...props.style,
          opacity: fadeAnim, // Bind opacity to animated value
        }}
      >
        {props.children}
      </Animated.View>
    );
  };

  React.useEffect(() => {
    const unsubscribe = navigation.addListener("blur", () => {
      // setMenuOpen(false);
      // AsyncStorage.setItem("menuOpen", "0");
    });

    return unsubscribe;
  }, [navigation]);

  React.useEffect(() => {
    if (!menuOpen) {
      handleAnimation();
    }
  }, [menuOpen]);

  return (
    <ImageBackground
      source={slides[slide]?.img}
      style={{ width: width, height: menuOpen ? height + 220 : height }}
      resizeMode="cover"
    >
      <ImageBackground
        source={HomeBGOverlay}
        style={{ width: width, height: "100%" }}
      >
        <SafeAreaView style={{ flex: 1, height: "100%" }}>
          <Pressable
            onPress={() => {
              setMenuOpen(false);
              AsyncStorage.setItem("menuOpen", "0");
              handleTranslateAnimation(true);
            }}
            style={{ height: "100%" }}
          >
            <Center h={"full"} justifyContent="space-between">
              <Center h="2/5" pt={10}>
                <Heading
                  textAlign="center"
                  maxW={"2/3"}
                  style={{ fontSize: 35 }}
                >
                  {slides[slide]?.text}
                </Heading>
              </Center>

              <Box h="2/5" alignSelf={"center"} mx="auto">
                <Box w={120} h={120} mx="auto">
                  {menuOpen && (
                    <Center>
                      <LinearGradient
                        colors={[
                          // "rgba(0, 184, 72, 1)",
                          // "rgba(0, 164, 140, 1)",
                          // "rgba(152, 90, 52, 1)",
                          // "rgba(179, 44, 74, 1)",
                          // "rgba(28, 89, 161, 1)",
                          "#fff",
                          "#fff",
                        ]}
                        style={{
                          width: 80,
                          height: 80,
                          position: "absolute",
                          top: 30,
                          borderRadius: 50,
                          justifyContent: "center",
                          alignContent: "center",
                        }}
                      >
                        {/* <Image
                          source={require("../assets/logo.png")}
                          style={{
                            backgroundColor: "#ffffff",
                            height: "100px",
                            width: "100p",
                            borderRadius: 100,
                            margin: "auto",
                            alignSelf: "center",
                          }}
                          resizeMode="contain"
                        /> */}

                        <ImageBackground
                          source={require("../assets/logo.png")}
                          style={{
                            width: 60,
                            height: 60,
                            position: "relative",
                            // alignItems: "center",
                            // justifyContent: "center",
                            // display: "flex",
                            // backgroundColor: "#ffffff",
                            left: 10,
                          }}
                          imageStyle={{
                            position: "relative",
                          }}
                          resizeMode="contain"
                        ></ImageBackground>
                      </LinearGradient>
                      <Animated.View
                        style={{
                          position: "absolute",
                          top: 30,
                          backgroundColor: "orange",
                          height: 80,
                          width: 80,
                          borderRadius: 100,
                          justifyContent: "center",
                          transform: [
                            {
                              translateX: animatedValue2.interpolate({
                                inputRange: [0, 1],
                                outputRange: [0, 1],
                              }),
                            },
                            {
                              translateY: animatedValue2.interpolate({
                                inputRange: [0, 1],
                                outputRange: [0, -120],
                              }),
                            },
                          ],
                        }}
                      >
                        <LinearGradient
                          colors={[
                            "rgba(107, 64, 36, 1)",
                            "rgba(206, 121, 67, 1)",
                          ]}
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: 100,
                            borderColor: "rgba(206, 121, 67, 1)",
                            borderWidth: 2,
                            justifyContent: "center",
                          }}
                        >
                          <Pressable
                            onPress={() =>
                              navigation.navigate("ResearchAndDev")
                            }
                          >
                            <Text
                              textAlign="center"
                              fontWeight="bold"
                              fontFamily="Rajdhani-Bold"
                            >
                              R&D
                            </Text>
                          </Pressable>
                        </LinearGradient>
                      </Animated.View>
                      <Animated.View
                        style={{
                          position: "absolute",
                          top: 30,
                          backgroundColor: "teal",
                          height: 80,
                          width: 80,
                          borderRadius: 100,
                          justifyContent: "center",
                          transform: [
                            {
                              translateX: animatedValue2.interpolate({
                                inputRange: [0, 1],
                                outputRange: [0, 120],
                              }),
                            },
                            {
                              translateY: animatedValue2.interpolate({
                                inputRange: [0, 1],
                                outputRange: [0, -20],
                              }),
                            },
                          ],
                        }}
                      >
                        <LinearGradient
                          colors={[
                            "rgba(141, 34, 57, 1)",
                            "rgba(218, 52, 88, 1)",
                          ]}
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: 100,
                            borderColor: "rgba(218, 52, 88, 1)",
                            borderWidth: 2,
                            justifyContent: "center",
                          }}
                        >
                          <Pressable
                            onPress={() => navigation.navigate("Production")}
                          >
                            <Text
                              textAlign="center"
                              fontWeight="bold"
                              fontFamily="Rajdhani-Bold"
                            >
                              Production
                            </Text>
                          </Pressable>
                        </LinearGradient>
                      </Animated.View>
                      <Animated.View
                        style={{
                          position: "absolute",
                          top: 30,
                          backgroundColor: "blue",
                          height: 80,
                          width: 80,
                          borderRadius: 100,
                          justifyContent: "center",
                          transform: [
                            {
                              translateX: animatedValue2.interpolate({
                                inputRange: [0, 1],
                                outputRange: [0, -120],
                              }),
                            },
                            {
                              translateY: animatedValue2.interpolate({
                                inputRange: [0, 1],
                                outputRange: [0, -20],
                              }),
                            },
                          ],
                        }}
                      >
                        <LinearGradient
                          colors={[
                            "rgba(0, 171, 146, 1)",
                            "rgba(0, 136, 116, 1)",
                          ]}
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: 100,
                            borderColor: "rgba(0, 136, 116, 1)",
                            borderWidth: 2,
                            justifyContent: "center",
                          }}
                        >
                          <Pressable
                            onPress={() =>
                              navigation.navigate("FarmerCentricProjects")
                            }
                          >
                            <Text
                              textAlign="center"
                              fontWeight="bold"
                              fontFamily="Rajdhani-Bold"
                            >
                              Farmer-centric
                            </Text>
                          </Pressable>
                        </LinearGradient>
                      </Animated.View>
                      <Animated.View
                        style={{
                          position: "absolute",
                          top: 30,
                          backgroundColor: "pink",
                          height: 80,
                          width: 80,
                          borderRadius: 100,
                          justifyContent: "center",
                          transform: [
                            {
                              translateX: animatedValue2.interpolate({
                                inputRange: [0, 1],
                                outputRange: [0, -60],
                              }),
                            },
                            {
                              translateY: animatedValue2.interpolate({
                                inputRange: [0, 1],
                                outputRange: [0, 120],
                              }),
                            },
                          ],
                        }}
                      >
                        <LinearGradient
                          colors={[
                            "rgba(0, 148, 58, 1)",
                            "rgba(1, 205, 81, 1)",
                          ]}
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: 100,
                            borderColor: "rgba(1, 205, 81, 1)",
                            borderWidth: 2,
                            justifyContent: "center",
                          }}
                        >
                          <Pressable
                            onPress={() => navigation.navigate("Distribution")}
                          >
                            <Text
                              textAlign="center"
                              fontWeight="bold"
                              fontFamily="Rajdhani-Bold"
                            >
                              Distribution
                            </Text>
                          </Pressable>
                        </LinearGradient>
                      </Animated.View>
                      <Animated.View
                        style={{
                          position: "absolute",
                          top: 30,
                          backgroundColor: "pink",
                          height: 80,
                          width: 80,
                          borderRadius: 100,
                          justifyContent: "center",
                          transform: [
                            {
                              translateX: animatedValue2.interpolate({
                                inputRange: [0, 1],
                                outputRange: menuOpen ? [0, 60] : [0, 0],
                              }),
                            },
                            {
                              translateY: animatedValue2.interpolate({
                                inputRange: [0, 1],
                                outputRange: [0, 120],
                              }),
                            },
                          ],
                        }}
                      >
                        <LinearGradient
                          colors={[
                            "rgba(25, 80, 145, 1)",
                            "rgba(39, 119, 216, 1)",
                          ]}
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: 100,
                            borderColor: "rgba(39, 119, 216, 1)",
                            borderWidth: 2,
                            justifyContent: "center",
                          }}
                        >
                          <Pressable
                            onPress={() =>
                              navigation.navigate("PublicPartnerships")
                            }
                          >
                            <Text
                              textAlign="center"
                              fontWeight="bold"
                              fontFamily="Rajdhani-Bold"
                            >
                              Partnerships
                            </Text>
                          </Pressable>
                        </LinearGradient>
                      </Animated.View>
                    </Center>
                  )}
                  {!menuOpen && (
                    <Pressable onPress={() => handleTranslateAnimation()}>
                      <ImageBackground
                        source={MenuButton}
                        style={{
                          width: 120,
                          height: 120,
                          position: "relative",
                        }}
                        imageStyle={{
                          width: 100,
                          height: 100,
                          left: 10,
                          marginTop: 10,
                          position: "absolute",
                        }}
                        resizeMode="contain"
                      >
                        <Center>
                          <Animated.Image
                            source={Twirl1}
                            resizeMode="cover"
                            style={{
                              position: "absolute",
                              top: -70,
                              height: 250,
                              width: 250,
                              transform: [{ rotate: spin2 }],
                            }}
                          />
                          <Animated.Image
                            source={Twirl2}
                            resizeMode="cover"
                            style={{
                              position: "absolute",
                              top: -70,
                              height: 250,
                              width: 250,
                              transform: [{ rotate: spin2 }],
                            }}
                          />
                          <Animated.Image
                            source={Twirl3}
                            resizeMode="cover"
                            style={{
                              position: "absolute",
                              top: -70,
                              height: 250,
                              width: 250,
                              transform: [{ rotate: spin3 }],
                            }}
                          />
                          <Animated.Image
                            source={Twirl4}
                            resizeMode="cover"
                            style={{
                              position: "absolute",
                              top: -70,
                              height: 250,
                              width: 250,
                              transform: [{ rotate: spin4 }],
                            }}
                          />
                          <Animated.Image
                            source={CircularText}
                            resizeMode="cover"
                            style={{
                              position: "absolute",
                              top: -15,
                              height: 150,
                              width: 150,
                              transform: [{ rotate: spin }],
                            }}
                          />
                        </Center>
                      </ImageBackground>
                    </Pressable>
                  )}
                </Box>

                {menuOpen && (
                  <HStack mt={"48"} space="10">
                    <LinearGradient
                      colors={[
                        "rgba(203, 203, 203, 1)",
                        "rgba(255, 255, 255, 1)",
                      ]}
                      style={styles.button}
                    >
                      <Pressable
                        color={"transparent"}
                        onPress={() => navigation.navigate("Gallery")}
                        style={{}}
                      >
                        <Text color={"#000"} fontWeight="bold">
                          Gallery
                        </Text>
                      </Pressable>
                    </LinearGradient>
                    <LinearGradient
                      colors={[
                        "rgba(203, 203, 203, 1)",
                        "rgba(255, 255, 255, 1)",
                      ]}
                      style={styles.button}
                    >
                      <Pressable
                        color={"transparent"}
                        onPress={() => navigation.navigate("Team")}
                        style={{}}
                      >
                        <Text color={"#000"} fontWeight="bold">
                          Team
                        </Text>
                      </Pressable>
                    </LinearGradient>
                  </HStack>
                )}
              </Box>
            </Center>
          </Pressable>
        </SafeAreaView>
      </ImageBackground>
    </ImageBackground>
  );
};

export default Home;

const styles = StyleSheet.create({
  button: {
    justifyContent: "center",
    backgroundColor: "green",
    borderRadius: 10,
    borderWidth: 2,
    borderColor: "rgba(255, 255, 255, 1)",
    paddingHorizontal: 15,
    paddingVertical: 5,
  },
});
